import React from 'react'

export default function AutoContent(
  startAuto: boolean,
  autoRollNumber: string,
  betCount: number,
) {
  const AutoRollContent = (
    <>
      <p>
        {!startAuto && Number(autoRollNumber) > betCount && betCount !== 0
          ? 'Resume On'
          : startAuto
          ? `Stop ${Number(autoRollNumber) > 0 ? 'On' : ''}`
          : 'Start'}
      </p>
      <span>
        {autoRollNumber === '0' || autoRollNumber === ''
          ? 'Auto'
          : Number(autoRollNumber) - betCount > 0
          ? Number(autoRollNumber) - betCount
          : 0}
      </span>
      <p>Roll</p>
    </>
  )
  return AutoRollContent
}
